module.exports = {"cookies":"Cookies","help":"Aide","privacy":"Confidentialité","signInButtonText":"Se connecter avec un Adobe ID","termsOfUse":"Conditions d’utilisation","updated":"MIS À JOUR"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpLogin/__localization__/ExpLogin/fr_fr.json
// module id = 946
// module chunks = 0